import MuiTypography, { TypographyProps as MuiTypographyProps } from '@mui/material/Typography';
import * as React from 'react';
export type { TypographyProps as MuiTypographyProps } from '@mui/material/Typography';

export interface TypographyProps extends Omit<MuiTypographyProps, 'component'> {
  component?: React.ElementType<any> | string | undefined;
}

export const Typography = (props: TypographyProps): JSX.Element => {
  return <MuiTypography {...props} />;
};

export default Typography;
